// Helpers for reporting upload failures to /api/errors/.
//
// JSON.stringify(new Error('x')) is '{}' — name/message/stack are
// non-enumerable — so a bare `JSON.stringify(err)` in an error report
// tells us nothing (error id 50782, 2026-10-24). These helpers turn the
// thrown value and the file being uploaded into plain, serialisable data.

export function serializeUploadError(error) {
    if (error === null || error === undefined) {
        return error;
    }
    const isErrorLike = error instanceof Error
        || (typeof error === 'object' && typeof error.message === 'string' && typeof error.name === 'string');
    if (!isErrorLike) {
        return error;
    }
    const out = {
        name: error.name,
        message: error.message,
    };
    if (typeof error.stack === 'string') {
        out.stack = error.stack;
    }
    if (error.code !== undefined) {
        out.code = error.code;
    }
    return out;
}

export function describeUploadFile(fileObject) {
    if (fileObject === null || fileObject === undefined) {
        return { kind: String(fileObject) };
    }
    const kind = (fileObject.constructor && fileObject.constructor.name) || typeof fileObject;
    return {
        kind,
        name: fileObject.name,
        type: fileObject.type,
        size: fileObject.size,
        lastModified: fileObject.lastModified,
    };
}
